import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@lemsar/auth/domains/services/auth.service';
import { catchError, tap } from 'rxjs/internal/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { NacoService } from '@naker/naco';

@Component({
    selector: 'lemsar-activation-page',
    template: `
        {{ message }}
    `,
})
export class ActivationPage implements OnInit {
    public message = 'Mohon menunggu, sedang mengaktivasi akun...';

    public constructor(private route: ActivatedRoute, private auth: AuthService, private router: Router, private naco: NacoService) {}

    public ngOnInit(): void {
        const code: string | null = this.route.snapshot.params.code;

        if (!code) {
            this.message = 'Kode tidak ditemukan!!';
        } else {
            this.auth
                .activateUser(code)
                .pipe(
                    tap(() => {
                        this.router.navigateByUrl('/dashboards/institutions');
                    }),
                    catchError((e: HttpErrorResponse) => (this.message = 'Gagal mengaktivasi user: ' + e.error.message)),
                )
                .subscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/auth/views/pages/activation.page.ts